export default __webpack_public_path__ + "static/media/digital_20_new.9a8a60f7.mp4";